import * as React from 'react';
import { connect } from 'react-redux';
import { addToFavorites, removeFromFavorites } from '../../actions/favoritesPageActions';
import {
    clearFilterParams,
    doNewSearchViaUrl,
    setFilterParam,
    setLoadingState,
    newFacetsSearch,
} from '../../actions/searchActions';
import { loadMoreUGCReviews, setReviewSorting } from '../../actions/ugcAction';
import { AdvisorTipps } from '../../components/AdvisorTipps';
import { CollapsibleDropDown } from '../../components/CollapsibleDropDown/CollapsibleDropDown';
import { CollapsibleDropDownTitle } from '../../components/CollapsibleDropDown/CollapsibleDropDownTitle';
import { CollapsibleText } from '../../components/CollapsibleDropDown/CollapsibleText';
import ReviewsDesktop from '../../components/DesktopReviews/DesktopReviews';
import { DynamicForm } from '../../components/DynamicForm/DynamicForm';
import { FurtherInfo } from '../../components/FurtherInfo/FurtherInfo';
import { GallerySliderSection } from '../../components/GallerySection';
import { AnchorIcon } from '../../components/Icons/AnchorIcon';
import { ImagesIcon } from '../../components/Icons/ImagesIcon';
import { InfoIcon } from '../../components/Icons/InfoIcon';
import { LikeIcon } from '../../components/Icons/LikeIcon';
import { StarIcon } from '../../components/Icons/StarIcon';
import { Section } from '../../components/NavigationPanel';
import { cruiseList } from '../../components/Recommendation/recommendation';
import RecommendationSection from '../../components/Recommendation/RecommendationSection';
import { recommendationWithDesc } from '../../components/Recommendation/recommendationWithDesc';
import { SearchMask } from '../../components/SearchFilters/SearchMask';
import { SearchSection } from '../../components/SearchFilters/SearchSection';
import { ZoneAndCompanyInputSelection } from '../../components/SearchFilters/ZoneAndCompanyInputSelection';
import { TeaserSlider } from '../../components/TeaserSlider';
import { TrackComponent } from '../../components/TrackComponent';
import * as Colors from '../../consts/variables';
import { IsomorphicHelpers } from '../../helpers/IsomorphicHelpers';
import {
    getFilter,
    setFilter,
    setFilterArray,
    transformOptions,
} from '../../helpers/searchHelpers';
import { __ } from '../../helpers/TranslationService';
import { IUGCReviewsReducer } from '../../interfaces/IUGCReviews';
import { IState } from '../../reducers';
import { IDestinationDetailPageReducer } from '../../reducers/destinationDetailPage';
import { IPageDataReducer } from '../../reducers/pageData';
import { ISearchReducer } from '../../reducers/search';
import { numberFormatter } from '../../helpers/TranslationService';
import { RecomendationList } from '../../components/RecomendationList/RecomendationList';
import { EventGoogleScript } from './EventGoogleScript';

import loadable from '@loadable/component';
import RecommendationZones from '../../components/RecommendationZones/RecommendationZones';
import classnames from 'classnames';
import { MarketContext } from '../../context/markets';
import { DestinationDesktopDetails } from './DestinationDesktopDetails';
import { DestinationMobileDetails } from './DestinationMobileDetails';
const MapboxMap = loadable(() => import('../Cruise/components/MapboxMap'), {
    ssr: false,
});

const styles: Record<string, React.CSSProperties> = {
    collapsibleMargin: {
        margin: '20px 15px',
    },
    sectionMargin: {
        margin: '0px 15px',
    },
    sectionBottomMargin: {
        marginBottom: 60,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'left',
        margin: '30px 15px 10px 0',
    },
    collapsibleWrapper: {
        padding: 5,
    },
    lastCollapsibleWrapper: {
        borderBottom: 0,
    },
    iconProps: {
        flex: '0 0 auto',
    },
    likeIconProps: {
        fill: Colors.darkAcqa,
        flex: '0 0 auto',
    },
    advisorChildStyle: {
        margin: 0,
    },
    childStyle: {},
    furtherInfoDropdown: {
        margin: 0,
        padding: 0,
    },
    starIcon: {
        fill: Colors.transparent,
        stroke: Colors.darkAcqa,
        strokeWidth: '30px',
    },
};

const iconProps = {
    width: 20,
    height: 20,
    rectFill: Colors.acqa,
    style: styles.iconProps,
};

interface StateProps {
    search: ISearchReducer;
    pageData: IPageDataReducer;
    destinationDetailPage: IDestinationDetailPageReducer;
    favorites: number[];
    reviewsData: IUGCReviewsReducer;
    homePage: any;
}

type Props = StateProps & typeof mapDispatchToProps;

class DestinationDetailPageClass extends React.Component<Props, any> {
    static contextType = MarketContext;
    constructor(props) {
        super(props);

        const deviceType = this.props?.pageData?.deviceType;

        const homePageLoaded = this.props.homePage.homePage === null;
        this.state = {
            showContent: !homePageLoaded,
            isDesktop: deviceType === 'desktop',
            firstLoad: true,
        };

        if (homePageLoaded) {
            this.props.setLoadingState(true);
            setTimeout(() => {
                this.props.setLoadingState(false);
                this.setState({ showContent: true });
            }, 1000);
        }
    }
    componentDidMount() {
        this.props.newFacetsSearch();
        this.resize();
        window.addEventListener('resize', this.resize);
        this.props.clearFilterParams(false);

        setFilterArray(
            ['company', 'zone'],
            this,
        )(['default', this.props.destinationDetailPage.zoneId]);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize = () => {
        if (IsomorphicHelpers.isServerSide) return;

        const width = window.innerWidth;

        const isDesktop = width >= 1200;
        if (this.state.isDesktop !== isDesktop || this.state.firstLoad) {
            this.setState({ isDesktop, firstLoad: false });
        }
    };

    filterDefaults = {
        dateMax: null,
        dateMin: null,
        zone: 'default',
        company: 'default',
    };

    render() {
        const { zoneNids, companyNids, topCompanies, topZones } = this.props.search.searchFacets;
        const { isCruise1st } = this.context.markets;
        const { dateMax, dateMin, zone, company } = getFilter(
            this.props.search,
            this.filterDefaults,
        );
        const { destinationDetailPage, pageData } = this.props;
        const numResults = this.props.search.searchFacets.numResults;
        const disableButton = numResults ? false : true;
        const loadingButton = !numResults && numResults !== 0;

        const disableMap: { [key in string]?: number[] } = {
            de: [35761, 1045, 56911],
            nl: [246916],
            us: [],
            au: [],
            c1uk: [],
            c1au: [],
        };

        const showMapboxMap =
            !disableMap[this.props.pageData?.appConfig.countryCode].find(
                (e: number) => e === this.props.destinationDetailPage.zoneId,
            ) && destinationDetailPage.harbours?.length;

        const teaserTracking = { category: 'mobile-teaser-destinationpage', label: 'destination' };
        const searchMaskProps = {
            pageType: 'Destination Page',
            dateMax,
            dateMin,
            onDateMinChange: setFilter('dateMin', this),
            onDateMaxChange: setFilter('dateMax', this),
            sticky: false,
            isLoading: loadingButton,
            isDisabled: disableButton,
            doNewSearchViaUrl: this.props.doNewSearchViaUrl,
            showSearchBtn: true,
            onDateChange: setFilterArray(['dateMin', 'dateMax'], this),
            numberOfFiltersUsed: this.props.search.filterParamsList.length,
            languageCode: this.props.pageData.appConfig.languageCode,
            countryCode: this.props.pageData.appConfig.countryCode,
            headline: this.props.destinationDetailPage.headline,
            title:
                (Number.isInteger(numResults) ? numberFormatter.format(numResults) + ' ' : '') +
                __('Search cruise', 'dreamlines'),
        };
        const zoneAndCompanyInputProps = {
            zoneNids,
            companyNids,
            topCompanies,
            topZones,
            zone,
            company,
            transformOptions: transformOptions,
            onCompanyChange: setFilter('company', this),
            onZoneChange: setFilter('zone', this),
            noPaddingTop: false,
        };
        const teaserData = this.props.destinationDetailPage.images.map((teaser) => {
            return {
                title: null,
                imageUrl: teaser,
                text: null,
                discount: null,
                price: null,
                currency: '',
                link: null,
                followLink: false,
            };
        });

        const furtherInfoTitleString = __(
            'Travel Tips for %s',
            'dreamlines',
            destinationDetailPage.title,
        );

        const advisor = this.props.destinationDetailPage.advisor;
        const advisorProps = {
            ...advisor,
            name: advisor.name || __('Call us', 'dreamlines'),
            phone: advisor.phone || this.props.pageData.brandConfig.phoneNumber,
        };

        const { name, phone, headline, text } = advisorProps;

        const isAdvisorDetailsPresent =
            name?.length || phone?.trim()?.length || text?.length || headline?.length;

        const advisorTitleString = headline;
        const advisorTitle = isAdvisorDetailsPresent && (
            <CollapsibleDropDownTitle title={advisorTitleString}>
                <LikeIcon width={20} height={20} style={styles.likeIconProps} />
            </CollapsibleDropDownTitle>
        );

        const infoIconProps = {
            width: 20,
            height: 20,
            rectFill: Colors.transparent,
        };
        const infoTitle = (
            <CollapsibleDropDownTitle
                title={furtherInfoTitleString}
                isSeoTitle={true}
                titleStyles={{ fontSize: '16px' }}
            >
                <InfoIcon {...infoIconProps} />
            </CollapsibleDropDownTitle>
        );
        const impressionIconProps = {
            width: 20,
            height: 20,
        };

        const impressionTitle = (
            <CollapsibleDropDownTitle
                title={`${this.props.destinationDetailPage.destinationName} ${__(
                    'impressions',
                    'dreamlines',
                )}`}
            >
                <ImagesIcon {...impressionIconProps} />
            </CollapsibleDropDownTitle>
        );

        const harbourTitleString = `${__(
            'Harbours for %s',
            'dreamlines',
            this.props.destinationDetailPage.destinationName,
        )}`;
        const harbourTitle = (
            <CollapsibleDropDownTitle title={harbourTitleString}>
                <AnchorIcon {...iconProps} />
            </CollapsibleDropDownTitle>
        );
        const harbourData = destinationDetailPage.harbours.map((val) => ({
            ...val,
            price: val.priceDualCurrency || val.price,
            url: val.harbourPageUri,
            currency: val.dualCurrency || val.currency,
        }));
        const recommendationProps = {
            pageData: this.props.pageData,
            cruiseRecommendations: this.props.destinationDetailPage.cruises.slice(
                0,
                this.state.isDesktop ? 6 : undefined,
            ),
            trackingData: teaserTracking,
            discountThreshold: this.props.pageData.discountThreshold,
        };

        const cruises = this.props.destinationDetailPage?.cruises;

        const eventCruises = cruises?.length >= 3 ? cruises.slice(0, 3) : [];

        const baseUrl = pageData.config.contentEndpoint;

        const TrackableAdvisorSection = TrackComponent(CollapsibleDropDown, {
            category: 'mobile-destinationpage',
            action: 'navigation',
            label: 'tips',
        });

        const { reviews, sortString, isLoading: areReviewsLoading } = this.props.reviewsData;
        const showReviewSection: boolean = Boolean(
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            reviews &&
                reviews.aggregation &&
                reviews.aggregation.data &&
                reviews.aggregation.data.attributes &&
                reviews.aggregation.data.attributes.overall &&
                parseInt(reviews.aggregation.data.attributes.overall.toString(), 10) > 0,
        );

        const reviewsTitleString = __('Reviwes for %s', 'dreamlines', destinationDetailPage.title);
        const reviewsTitle = (
            <CollapsibleDropDownTitle
                isSeoTitle
                title={reviewsTitleString}
                titleStyles={{ fontSize: '16px' }}
            >
                <StarIcon {...iconProps} style={styles.starIcon} />
            </CollapsibleDropDownTitle>
        );
        const ugcFilterParams = destinationDetailPage.harbours
            .map((_) => `filterParams[waypoints][]=${_.harbourNid}`)
            .join('&');

        const offerUrl = `/${pageData.brandConfig.slugsObj.searchresults}?filterParams[zone][0]=${zone}`;
        const galleryImages = this.props.destinationDetailPage.images;

        const dynamicFormClasses = classnames('dynamicForm', { transparent: isCruise1st });

        const navigationPanelSections: Section[] = showMapboxMap
            ? ['overview', 'offers', 'harbours', 'reviews', 'furtherInfo']
            : ['overview', 'offers', 'reviews', 'furtherInfo'];

        if (isCruise1st) {
            navigationPanelSections.length = 0; // hide page navigation for cruise1st markets
        }

        const hasHarbourData = harbourData.length > 0;

        const desktopSections = {
            zoneRecommendation: () =>
                this.props.destinationDetailPage?.zoneTabs?.length > 0 ? (
                    <RecommendationZones
                        title={__(
                            'Our Best %s Deals',
                            'dreamlines',
                            this.props.destinationDetailPage.title,
                        )}
                        key="zoneRecommendation"
                        data={this.props.destinationDetailPage?.zoneTabs}
                    />
                ) : (
                    desktopSections.recommendation()
                ),
            recommendation: () => (
                <RecommendationSection
                    key="recommendation"
                    data={cruiseList(recommendationProps)}
                    title={__('Cruise Offers for %s', 'dreamlines', destinationDetailPage.title)}
                    favorites={this.props.favorites}
                    addToFavorites={this.props.addToFavorites}
                    removeFromFavorites={this.props.removeFromFavorites}
                    offerUrl={offerUrl}
                />
            ),
            gallery: () => (
                <GallerySliderSection
                    key="gallery"
                    offerUrl={offerUrl}
                    headline={destinationDetailPage.headline}
                    content={destinationDetailPage.description}
                    galleryImages={galleryImages}
                />
            ),
            form: () => (
                <DynamicForm
                    key="form"
                    className="dynamicForm row"
                    headline={destinationDetailPage.title}
                />
            ),
            advisor: () =>
                advisor.headline &&
                advisor.text &&
                this.props.pageData.brandConfig.phoneNumber && (
                    <div className="row advisorSection" key="advisor">
                        <h2 className="headline">{advisorTitleString}</h2>
                        <AdvisorTipps {...advisorProps} />
                    </div>
                ),
            ships: () =>
                showMapboxMap ? (
                    <div className="row harboursSection" id="harbours">
                        <h2
                            className="headline"
                            dangerouslySetInnerHTML={{ __html: harbourTitleString }}
                        />

                        <MapboxMap
                            pageType="destination"
                            markerMode="waypoints"
                            waypoints={this.props.destinationDetailPage.harbours.map(
                                (item: any) => ({
                                    title: item.location.city,
                                    lat: parseFloat(item.location.latitude),
                                    long: parseFloat(item.location.longitude),
                                    image: item.image,
                                    city: item.location.city,
                                    description: item.description,
                                }),
                            )}
                            draggable={false}
                            zoomControl={false}
                            countryCode={this.props.pageData.appConfig.countryCode}
                        />
                        <RecommendationSection
                            data={recommendationWithDesc({
                                data: harbourData,
                                discountThreshold: this.props.pageData.discountThreshold,
                                showDescription: false,
                            })}
                            collapsibleComponent={true}
                        />

                        {destinationDetailPage.staticHarbours &&
                            destinationDetailPage.staticHarbours.length > 0 && (
                                <div className="container recomendation-list mb-5">
                                    <RecomendationList
                                        links={destinationDetailPage.staticHarbours}
                                    />
                                </div>
                            )}
                    </div>
                ) : null,
            seo: () => (
                <div className="row furtherInfoSection" key="seo" id="furtherInfo">
                    <h2
                        className="headline"
                        dangerouslySetInnerHTML={{ __html: furtherInfoTitleString }}
                    />
                    <div
                        className="furtherInfoSectionContent"
                        dangerouslySetInnerHTML={{
                            __html: destinationDetailPage.seo.text,
                        }}
                    />
                </div>
            ),
            reviews: () =>
                reviews?.rating?.data?.length > 0 ? (
                    <div className="row ugcSection" id="reviews">
                        <h2 className="headline">{__(reviewsTitleString, 'dreamlines')}</h2>
                        <div>
                            <ReviewsDesktop
                                reviews={reviews}
                                offers={this.props.destinationDetailPage.offers}
                                priceCurrency={this.props.pageData.appConfig.defaultCurrency}
                                loadMoreReviews={this.props.loadMoreUGCReviews}
                                setSortString={this.props.setReviewSorting}
                                sortString={sortString}
                                filterParams={ugcFilterParams}
                                reviewsType="destinationReviews"
                                shipTitle={'pageData.shipTitle'}
                                googleScriptName={destinationDetailPage.destinationName}
                                isLoading={areReviewsLoading}
                            />
                        </div>
                    </div>
                ) : null,
        };

        const mobileSections = {
            zoneRecommendation: desktopSections.zoneRecommendation,
            form: () => (
                <div style={styles.sectionBottomMargin} key="form">
                    <DynamicForm
                        className={dynamicFormClasses}
                        headline={this.props.destinationDetailPage.title}
                    />
                </div>
            ),
            recommendation: () => (
                <div style={styles.sectionBottomMargin} key="recommendation">
                    <RecommendationSection
                        data={cruiseList(recommendationProps)}
                        title={__(
                            'Cruise Offers for %s',
                            'dreamlines',
                            this.props.destinationDetailPage.headline,
                        )}
                        favorites={this.props.favorites}
                        addToFavorites={this.props.addToFavorites}
                        removeFromFavorites={this.props.removeFromFavorites}
                        offerUrl={offerUrl}
                    />
                </div>
            ),
            gallery: () => (
                <div style={styles.sectionBottomMargin} key="gallery">
                    <TeaserSlider teaserData={teaserData} />
                </div>
            ),
            description: () =>
                destinationDetailPage.description && (
                    <div style={styles.sectionMargin} key="description">
                        <h2 style={styles.title}>{destinationDetailPage.headline}</h2>
                        <CollapsibleText text={destinationDetailPage.description} />
                    </div>
                ),
            ships: () =>
                hasHarbourData && (
                    <div style={styles.sectionBottomMargin} key="ships">
                        <div style={styles.sectionMargin}>
                            <h2 style={styles.title}>{harbourTitle}</h2>
                        </div>
                        <RecommendationSection
                            data={recommendationWithDesc({
                                data: harbourData,
                                discountThreshold: this.props.pageData.discountThreshold,
                                showDescription: false,
                            })}
                            collapsibleComponent={true}
                        />
                    </div>
                ),
            advisor: () =>
                Boolean(isAdvisorDetailsPresent) && (
                    <div style={styles.sectionMargin} key="advisor">
                        <TrackableAdvisorSection
                            title={advisorTitle}
                            wrapperStyle={styles.collapsibleWrapper}
                            childStyle={styles.advisorChildStyle}
                        >
                            <AdvisorTipps {...advisorProps} />
                        </TrackableAdvisorSection>
                    </div>
                ),
            seo: () =>
                destinationDetailPage.seo.text && (
                    <div
                        style={{ ...styles.sectionMargin, ...styles.sectionBottomMargin }}
                        key="seo"
                    >
                        <h2 style={styles.title}>{__('Further information', 'dreamlines')}</h2>
                        <CollapsibleText
                            uncollapsedSpace={495}
                            text={destinationDetailPage.seo.text}
                        />
                    </div>
                ),
            reviews: () =>
                showReviewSection && (
                    <div style={styles.sectionMargin} key="reviews">
                        <CollapsibleDropDown
                            title={reviewsTitle}
                            wrapperStyle={{
                                ...styles.collapsibleWrapper,
                                ...styles.lastCollapsibleWrapper,
                            }}
                        >
                            <ReviewsDesktop
                                reviews={reviews}
                                offers={this.props.destinationDetailPage.offers}
                                priceCurrency={this.props.pageData.appConfig.defaultCurrency}
                                loadMoreReviews={this.props.loadMoreUGCReviews}
                                setSortString={this.props.setReviewSorting}
                                sortString={sortString}
                                filterParams={ugcFilterParams}
                                reviewsType="destinationReviews"
                                shipTitle={'pageData.shipTitle'}
                                googleScriptName={destinationDetailPage.destinationName}
                                isLoading={areReviewsLoading}
                            />
                        </CollapsibleDropDown>
                    </div>
                ),
            staticHarbours: () =>
                destinationDetailPage.staticHarbours &&
                destinationDetailPage.staticHarbours.length > 0 && (
                    <div
                        key="staticHarbours"
                        className="recomendation-list"
                        style={styles.sectionBottomMargin}
                    >
                        <RecomendationList links={destinationDetailPage.staticHarbours} />
                    </div>
                ),
        };
        return (
            <div className="destinationPage">
                <SearchSection
                    backgroundImage={destinationDetailPage.headerImage}
                    headline={destinationDetailPage.headline}
                    subHeadline={destinationDetailPage.subHeadline}
                >
                    <SearchMask {...searchMaskProps}>
                        <ZoneAndCompanyInputSelection {...zoneAndCompanyInputProps} />
                    </SearchMask>
                </SearchSection>
                <div
                    className="container"
                    style={this.state.isDesktop ? styles.sectionBottomMargin : null}
                >
                    {this.state.isDesktop && (
                        <DestinationDesktopDetails
                            breadcrumbs={destinationDetailPage.breadcrumbs}
                            navigationItems={navigationPanelSections}
                            offerUrl={offerUrl}
                            sections={desktopSections}
                        />
                    )}
                    {!this.state.isDesktop && (
                        <DestinationMobileDetails
                            breadcrumbs={destinationDetailPage.breadcrumbs}
                            sections={mobileSections}
                        />
                    )}
                    {eventCruises.map((eventCruise) => (
                        <EventGoogleScript
                            key={eventCruise.cruiseNid}
                            eventCruise={eventCruise}
                            baseUrl={baseUrl}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IState): StateProps => ({
    search: state.search,
    pageData: state.pageData,
    destinationDetailPage: state.destinationDetailPage,
    favorites: state.favoritePage.favorites,
    reviewsData: state.reviews,
    homePage: state.homePage,
});

const mapDispatchToProps = {
    setFilterParam,
    doNewSearchViaUrl,
    addToFavorites,
    removeFromFavorites,
    clearFilterParams,
    loadMoreUGCReviews,
    setReviewSorting,
    setLoadingState,
    newFacetsSearch: newFacetsSearch as any,
};

export const DestinationDetailPage = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DestinationDetailPageClass);
export default DestinationDetailPage;
